export const SET_DASHBOARD_VARIABLES = "SET_DASHBOARD_VARIABLES";
export const SET_DASHBOARD_VARIABLE_VALUE = "SET_DASHBOARD_VARIABLE_VALUE";
export const SET_PLUGIN_VARIABLE_ASSIGNMENTS = "SET_PLUGIN_VARIABLE_ASSIGNMENTS";
export const RESET_DASHBOARD_VARIABLE_VALUE = "RESET_DASHBOARD_VARIABLE_VALUE";
export const RESET_DASHBOARD_VARIABLE_VALUES = "RESET_DASHBOARD_VARIABLE_VALUES";

/**
 * Sets dashboard variable definitions (id, name, dataType, defaultValue)
 */
export const setDashboardVariables = (definitions) => {
    let payload = definitions;
    if (definitions instanceof Map) {
        payload = Array.from(definitions.values());
    }

    return {
        type: SET_DASHBOARD_VARIABLES,
        payload: payload
    };
};

/**
 * Sets a specific dashboard variable's active value
 */
export const setDashboardVariableValue = (variableId, value) => {
    return {
        type: SET_DASHBOARD_VARIABLE_VALUE,
        payload: { variableId, value }
    };
};

/**
 * Resets a specific dashboard variable's active value
 */
export const resetDashboardVariableValue = (variableId) => {
    return {
        type: RESET_DASHBOARD_VARIABLE_VALUE,
        payload: variableId
    }
}

/**
 * Resets all active values
 */
export const resetDashboardVariableValues = () => {
    return {
        type: RESET_DASHBOARD_VARIABLE_VALUES
    }
}